module.exports = __webpack_public_path__ + "img/1487980715.fb77a16f.jpg";